import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-home-box-icon',
  templateUrl: './home-box.component.html'
})
export class HomeBoxComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
